import React from 'react';
import HomeHero from '../components/home/HomeHero';
import HomeProblem from '../components/home/HomeProblem';
import HomeHowItWorks from '../components/home/HomeHowItWorks';
import HomeService from '../components/home/HomeService';
import HomeWhy from '../components/home/HomeWhy';
import HomeProcess from '../components/home/HomeProcess';
import HomeBestFit from '../components/home/HomeBestFit';
import HomePricing from '../components/home/HomePricing';
import HomeAIVoice from '../components/home/HomeAIVoice';
import HomeFAQ from '../components/home/HomeFAQ';
import HomeFinalCTA from '../components/home/HomeFinalCTA';
import HomeBooking from '../components/home/HomeBooking';
import HomeFooter from '../components/home/HomeFooter';
import AIVoiceWorkflow from '../components/workflow/AIVoiceWorkflow';

const Home = () => (
  <div style={{ background: '#f0fdf4', color: '#052e16' }}>
    <HomeHero />
    <HomeProblem />
    <HomeHowItWorks />
    <AIVoiceWorkflow />
    <HomeService />
    <HomeWhy />
    <HomeProcess />
    <HomeBestFit />
    <HomePricing />
    <HomeAIVoice />
    <HomeFAQ />
    <HomeFinalCTA />
    <HomeBooking />
    <HomeFooter />
  </div>
);

export default Home;